import { TemporaryDataPopup } from 'borispage/admintab/doctab/AdminNewDocumentPopupPage';
import { langutil } from 'language/langutil';
import { ITemporaryListData } from 'repositories/SsqDataRepository';
import svcs from 'services';
import { formatDateTime } from 'util/formatDateTime';

export const TempDataPopupWrap = ({ trans, temporaryDataList, history }) => {
  return (
    <TemporaryDataPopup>
      <p className={'tit'}>{trans('I18N_SAVE_LIST')}</p>
      {(temporaryDataList || []).map((item: ITemporaryListData, index: number) => {
        return (
          <div
            key={`temp-${index}`}
            onClick={async () => {
              const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
              const url = `/${country}/${lang}/community/temp/${item.temporaryId}/${item.temporaryDocumentId}`;
              if (url === history?.location?.pathname) {
                window.location.reload();
              } else {
                //console.log("history", history, url);
                history.push(url);
              }
            }}
            title={item.docTitle}
          >
            <div className={'Tempo_item_tit_wrap'}>
              <span className={'Tempo_item_tit'}>{item.docTitle || trans('I18N_NO_TITLE')}</span>
              <span className={'Tempo_item_new'}>{item.temporaryDocumentId > 0 ? 'Update' : 'New'}</span>
            </div>
            <span className={'Tempo_item_time'}>{formatDateTime(new Date(item.updateTime))}</span>
          </div>
        );
      })}
      <p className={'txt'}>{trans('I18N_SAVE_LIST_DESC')}</p>
    </TemporaryDataPopup>
  );
};
